import styled from 'styled-components';

import { LabelStyledProps } from './styledProps';

export const H2 = styled.h2`
  display: inline;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  text-align: ${(props: LabelStyledProps) => (props && props.textAlign) ? `${props.textAlign}` : 'left'};
`;
